// The price stickers' PDF: one page per piece of the roll (62 mm wide, one sticker tall), each holding one sticker or two
// side by side. Pages are the same drawings as the preview, at 600 dots per inch.
import { drawPage, heightMm, ROLL_WIDTH_MM, type Sticker, type StickerSettings } from '@/entities/price-sticker';

// `px` holds each page's sticker sizes (one per sticker on the page).
export async function makeStickerPdf(pages: Sticker[][], s: StickerSettings, px: number[][], fileName = 'price-stickers.pdf') {
  const { jsPDF } = await import('jspdf');
  const h = heightMm(s.height);
  const pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: [ROLL_WIDTH_MM, h], compress: true });
  const canvas = document.createElement('canvas');
  pages.forEach((page, i) => {
    if (i > 0) pdf.addPage([ROLL_WIDTH_MM, h], 'landscape');
    drawPage(canvas, page, s, px[i]!);
    pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, ROLL_WIDTH_MM, h, undefined, 'FAST');
  });
  pdf.save(fileName);
}
